import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { TennisBall, ArrowLeft } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
    const { login, user, ready } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (ready && user) navigate("/admin", { replace: true });
    }, [ready, user, navigate]);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email.trim(), password);
        setLoading(false);
        if (res.ok) {
            toast.success("Connexion réussie");
            navigate("/admin", { replace: true });
        } else {
            toast.error(res.error || "Échec de la connexion");
        }
    };

    return (
        <div className="min-h-screen bg-navy-deep text-white flex flex-col relative overflow-hidden">
            <div className="absolute inset-0 court-lines opacity-20" />
            <div className="absolute inset-0 noise" />
            <div className="relative p-6">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-clay">
                    <ArrowLeft weight="bold" size={18} /> Retour au site
                </Link>
            </div>
            <div className="relative flex-1 grid place-items-center px-4 pb-16">
                <div className="w-full max-w-sm">
                    <div className="flex flex-col items-center mb-8">
                        <img src="/logo.png" alt="TCLT" className="h-20 w-20 object-contain mb-4" />
                        <h1 className="font-display font-black text-2xl tracking-tight">Espace Admin</h1>
                        <p className="text-slate-400 text-sm mt-1">Tennis Club La Turballe</p>
                    </div>
                    <form onSubmit={submit} className="bg-white text-navy rounded-xl p-6 space-y-4" data-testid="admin-login-form">
                        <div>
                            <label className="overline text-slate-400 block mb-1.5">Email</label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                data-testid="admin-email-input"
                                className="w-full rounded-lg border border-slate-200 px-4 py-3 outline-none focus:border-clay focus:ring-2 focus:ring-clay/30 transition"
                                placeholder="admin@tclt.fr"
                            />
                        </div>
                        <div>
                            <label className="overline text-slate-400 block mb-1.5">Mot de passe</label>
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="admin-password-input"
                                className="w-full rounded-lg border border-slate-200 px-4 py-3 outline-none focus:border-clay focus:ring-2 focus:ring-clay/30 transition"
                                placeholder="••••••••"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="admin-login-submit"
                            className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-clay px-4 py-3 font-bold text-white transition-colors duration-200 hover:bg-clay-dark disabled:opacity-60"
                        >
                            <TennisBall weight="fill" size={18} /> {loading ? "Connexion…" : "Se connecter"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
